module.exports = __webpack_public_path__ + "static/media/pic_top.d38df8ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_top.jpg
// module id = 657
// module chunks = 0